import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarPetaRisikoAdmin from "../../components/TopBarPetaRisikoAdmin";
import PetaRisiko from "../../components/PetaRisiko";

function HalamanDataPetaRisikoAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarPetaRisikoAdmin />

        {/* Konten utama */}
        <div className="main-content-pasien">
          <PetaRisiko />
        </div>
      </div>
    </div>
  );
}

export default HalamanDataPetaRisikoAdmin;
